module.exports = __webpack_public_path__ + "img/crash.08c1592b.png";